import { render, staticRenderFns } from "./RelatoriosFilas.vue?vue&type=template&id=d16577f4&scoped=true&"
import script from "./RelatoriosFilas.vue?vue&type=script&lang=js&"
export * from "./RelatoriosFilas.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosFilas.vue?vue&type=style&index=0&id=d16577f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16577f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
